// Smart Sash Admin Panel - Compliance Score Badge
// Color-coded badge for sash compliance score

import React from 'react';
import { ComplianceLevel } from '@/models';

interface ComplianceBadgeProps {
  score: number;
  level: ComplianceLevel;
}

const levelToVariant: Record<ComplianceLevel, string> = {
  [ComplianceLevel.Green]: 'success',
  [ComplianceLevel.Yellow]: 'warning',
  [ComplianceLevel.Red]: 'danger',
};

export const ComplianceBadge: React.FC<ComplianceBadgeProps> = ({ score, level }) => {
  const variant = levelToVariant[level];
  return (
    <span className={`badge bg-${variant}`}>
      {score}% ({level})
    </span>
  );
};
